import 'utils/polyfills';

import React from 'react'
import ReactDOM from 'react-dom'
import createHistory from 'history/createBrowserHistory'
import AppContainer from 'react-hot-loader/lib/AppContainer'
import { ApolloClient, createNetworkInterface } from 'apollo-client'
import { ApolloProvider } from 'react-apollo'
import { Router } from 'react-router-dom'

import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'
import { createUploadLink } from 'apollo-upload-client'


import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import breakpointReducer from './reducers/breakpointReducer'
import loadingReducer from './reducers/loadingReducer'

import App from './components/App'
import { ScrollToTop } from 'elements'
import { matchPath } from 'react-router'
import { LANGUAGES } from './constants'

import config from '../config'


window.onerror = (error) => {
  window.gtag && gtag('event', 'exception', {
    'description': error,
  });
};

process.on('uncaughtException', (error) => {
  window.gtag && gtag('event', 'exception', {
    'description': error,
  });
});


const history = createHistory()


// console.log(config);
// console.log(process.env.NODE_ENV);

// šeit ja produkcija tad īstais url, ja steidzings tad otrs
// ja kokālais tad cits
// const client = new ApolloClient({
//   initialState: window.__APOLLO_STATE__,
//   ssrForceFetchDelay: 100,
//   networkInterface: createNetworkInterface({
//     uri: config.uri
//   })
// })

const client = new ApolloClient({
  ssrForceFetchDelay: 100,
  link: createUploadLink({
    uri: config.uri
  }),
  cache: new InMemoryCache({
    dataIdFromObject: object => {
      const match = matchPath(history.location.pathname, {
        path: '/:lang',
        exact: false,
        strict: false
      });

      let lang = 'lv'
      if (match && LANGUAGES.find(lang => lang._id === match.params.lang)) {
        lang = match.params.lang;
      }

      const defaultDataId = defaultDataIdFromObject(object);
      if (defaultDataId) {
        return `${lang}:${defaultDataId}`;
      } else {
        return defaultDataId; // null
      }
    }
  }).restore(window.__APOLLO_STATE__),
});


// izveidojam jaunu store un ieleikam tajā initialState no clienta
// nezkapec nevar piesaistit client.store ApolloProvider
const store = createStore(
  combineReducers({
    breakpoint: breakpointReducer,
    global_loading: loadingReducer
  }),
  window.__REDUX_STATE__, // initial state
  // client.initialState, // initial state
  compose(
    // applyMiddleware(client.middleware()),
    // If you are using the devToolsExtension, you can add it here also
    typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : f => f
  )
)

const render = App =>
  ReactDOM.hydrate(
    <AppContainer>
      <ApolloProvider store={store} client={client}>
        <Router history={history}>
          <ScrollToTop>
            <App history={history} />
          </ScrollToTop>
        </Router>
      </ApolloProvider>
    </AppContainer>,
    document.getElementById('root')
  )

if (process.env.NODE_ENV === 'development' && module.hot) {
  module.hot.accept('./components/App.js', () => {
    const App = require('./components/App').default
    render(App)
  })
}

render(App)



// WEBPACK FOOTER //
// ./src/index.js